import { render } from "./ToastCloseBtn.vue?vue&type=template&id=52db8b00&scoped=true&lang=pug"
const script = {}

import "./ToastCloseBtn.vue?vue&type=style&index=0&id=52db8b00&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52db8b00"]])

export default __exports__